import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { ApiPath } from '../models/api-path';

@Injectable()
export class CachingPrefixesInterceptor implements HttpInterceptor {
  responsePrefixes = new Map()
  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.caching(request)) {
      return next.handle(request)
    }
    const cache = this.responsePrefixes.get(request.urlWithParams)
    if (cache) {
      return of(cache)
    }
    return next.handle(request).pipe(tap(response => {
      this.responsePrefixes.set(request.urlWithParams, response)
    }));
  }

  caching(request: HttpRequest<unknown>): boolean {
    return request.urlWithParams.includes(`${ApiPath.common.base}/prefixes`)
  }
}
